export default "__VITE_ASSET__CSnYNm0L__"